/**
 * Created by wjjn3481 on 2017/4/5.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import BaseData from 'store/modules/baseData'
import User from 'store/modules/user'
import NeedIds from 'store/modules/needIds'

import App from 'store/modules/app'


import { Message } from 'element-ui'

Vue.use(Vuex)

let timer = null

const store = new Vuex.Store({
    state: {
        loading: false,
        folding: false
    },
    modules: {
        user: User,
        app: App,
        baseData: BaseData,
        needIds: NeedIds
    },
    mutations: {
        LOADING (state, boolean) {
            state.loading = boolean
        },
        FOLDING (state, boolean) {
            state.folding = boolean
        },
        MESSAGE_ERROR (state, msg) {
            Message.error(msg)
        },
        MESSAGE_SUCCESS (state, msg) {
            Message.success(msg)
        }
    },
    actions: {
        LOADING ({commit}, boolean) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                commit('LOADING', !!boolean)
            }, 250)
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js